export class EventDateConstants {
  /**
   * Wall-clock "no end date" / ongoing sentinel. Mirrors the backend marker
   * (`new DateTime(2099, 12, 31)`) the event handlers persist when an end date
   * is omitted, so a habit/reflection keeps appearing on every future day.
   *
   * Sending this explicitly (instead of echoing the start date) is what lets
   * the backend tell "ongoing" apart from a deliberate single-day item where
   * end == start (AB#8313).
   */
  static readonly NO_END_DATE_WALL_CLOCK = '2099-12-31T00:00:00';
}
